import { FC } from 'react';
import { Skeleton } from './skeleton';

interface SkeletonListProps {
  count: number;
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
}

export const SkeletonList: FC<SkeletonListProps> = ({
  count,
  ...skeletonProps
}) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <Skeleton key={index} {...skeletonProps} />
    ))}
  </>
);
